// angular imports
import { Injectable, OnDestroy } from "@angular/core";

// local imports
import {
  AppAvailability,
  AppDataChangedMessage,
  AppDataHttpService,
  AppManagementModel,
} from "@app/core";
import { Messenger } from "@app/shared";

@Injectable({
  providedIn: "root",
})
export class AppStateService implements OnDestroy {
  private _initialized = false;
  public AppManagementState: AppManagementModel;

  constructor(
    private startupHttpService: AppDataHttpService,
    private messenger: Messenger,
  ) {}

  async initialize() {
    if (this._initialized) return;

    this.AppManagementState = new AppManagementModel();

    const appsHttpResult = this.startupHttpService.getApps();
    try {
      const appResponse = await appsHttpResult.response;
      this.AppManagementState.apps.set(AppAvailability.fromDto(appResponse));
      this.messenger.send(new AppDataChangedMessage(this.AppManagementState));
    } catch (error) {}

    this._initialized = true;
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
    this._initialized = false;
  }
}
